const SCROLL_LOCK_STYLE_PROPS = [
  "overflow",
  "overflow-x",
  "overflow-y",
  "overscroll-behavior",
  "padding-right",
  "padding-left",
  "padding-top",
  "margin-right",
  "pointer-events",
  "position",
] as const;

const SCROLL_LOCK_CLASSES = [
  "with-scroll-bars-hidden",
  "right-scroll-bar-position",
  "width-before-scroll-bar",
] as const;

export const DOCUMENT_SCROLL_LOCK_RESTORE_DELAY_MS = 400;

export function hasOpenScrollLockingOverlay(doc: Document): boolean {
  return Boolean(
    doc.querySelector(
      '[role="dialog"][data-state="open"], [role="alertdialog"][data-state="open"]',
    ),
  );
}

function clearScrollLockStyles(element: HTMLElement): void {
  for (const property of SCROLL_LOCK_STYLE_PROPS) {
    element.style.removeProperty(property);
  }
  element.style.removeProperty("--removed-body-scroll-bar-size");
  element.classList.remove(...SCROLL_LOCK_CLASSES);
}

export function restoreDocumentScrollLock(doc: Document): void {
  doc.body.removeAttribute("data-scroll-locked");
  clearScrollLockStyles(doc.body);
  clearScrollLockStyles(doc.documentElement);
}

export function restoreDocumentScrollLockIfIdle(doc: Document): boolean {
  if (hasOpenScrollLockingOverlay(doc)) {
    return false;
  }

  restoreDocumentScrollLock(doc);
  return true;
}

export function scheduleIdleDocumentScrollLockRestore<T>(
  doc: Document,
  schedule: (callback: () => void, delayMs: number) => T,
  cancel: (id: T) => void,
  delaysMs: readonly number[] = [0, DOCUMENT_SCROLL_LOCK_RESTORE_DELAY_MS],
): () => void {
  const ids = delaysMs.map((delayMs) =>
    schedule(() => {
      restoreDocumentScrollLockIfIdle(doc);
    }, delayMs),
  );

  return () => {
    for (const id of ids) {
      cancel(id);
    }
  };
}
